// extracted by mini-css-extract-plugin
export default {"events_section":"MainEvents_events_section__6lmSB","heading":"MainEvents_heading__yyS4s","events_container":"MainEvents_events_container__jpHyc"};